import React, { useEffect, useState } from "react";
import {
  ClientContainer,
  withContainers,
} from "../../containers/gamification";
import { ShoppingCartContainer } from "../../containers/gamification2026";

import CartButtons from "./CartButtons";
import CartWarning from "./CartWarning";
import CartItemsTable from "./CartItemsTable";
import EmptyStateLayout from "../shared/EmptyStateLayout";
import { ReactComponent as NoStore } from "../../../assets/img/no_store.svg";
import CustomLink from "../shared/CustomLink";
import PopUp from "../shared/PopUp";
import { t } from "../../../i18n";  
import CartContainer from "./CartContainer";
import { cartIsAllowed } from "../normalizer";

const CartItems = (props) => {
  const {
    client = {},
    cart,
    onIncreaseItem,
    onDecreaseItem,
    onRemoveItem,
    checkout,
    campaign,
    campaignUser,
    onReturnToCatalog,
    onCheckCartItem,
    allDigitalCards,
    walletConfig = {},
  } = props;

  const message = t("gamification2026.cart.add-items-link");
  const path = `/catalog`;

  // Digital-only carts surface an informational warning above the totals. The
  // message text is backend-sourced via the wallet configuration payload.
  const digitalCardWarningMessage = walletConfig.digitalCardWarningMessage;

  const [allowed, setAllowed] = useState(false);
  const [toRemove, setToRemove] = useState([]);
  
  useEffect(()=>{
    const {allowed, toRemove } = cartIsAllowed(cart)
    setAllowed(allowed)
    setToRemove(toRemove)
  }, [cart])

  return cart.items.length > 0 ? (
    <>
      {allDigitalCards && digitalCardWarningMessage ? (
        <CartWarning text={digitalCardWarningMessage} />
      ) : null}
      <CartContainer
        currencyLabel={client.currency_label}
        cart={cart}
        campaign={campaign}
        campaignUser={campaignUser}
        onCheckCartItem={onCheckCartItem}
        onIncreaseItem={onIncreaseItem}
        onDecreaseItem={onDecreaseItem}
        onRemoveItem={onRemoveItem}
        checkout={checkout}
      />
      {allowed == false && !!toRemove.length && (
        <PopUp isOpenValue={true} title={t("gamification2026.cart.attention")}>
          <div className="gl2026-modal__callout gl2026-modal__callout--warning">
            <div className="gl2026-modal__callout-content">
              <p className="gl2026-modal__callout-text">
                {t("gamification2026.cart.card-only-warning")}
              </p>
              <p className="gl2026-modal__callout-text">
                {t("gamification2026.cart.remove-products-warning")}
              </p>
              {toRemove.map((item) => (
                <p key={item} className="gl2026-modal__callout-text">— {item}</p>
              ))}
            </div>
          </div>
        </PopUp>
      )}
    </>
  ) : (
    <div>
      <EmptyStateLayout message={message}>
        <div className="gl-no-store">
          <NoStore className="mr-3 dead-grey gl-no-store__image"></NoStore>
        </div>
        <h2 className="mb-5">{t("gamification2026.cart.empty-cart")}</h2>
      </EmptyStateLayout>
      <div className="flex justify-center">
        <CustomLink to={path} primary>
          {t("gamification2026.cart.prize-store")}
        </CustomLink>
      </div>
    </div>
  );
};

export default withContainers(CartItems, [
  ShoppingCartContainer,
  ClientContainer,
]);
